"use strict";

exports.__esModule = true;
var _VimanaIcon = require("./VimanaIcon");
Object.keys(_VimanaIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VimanaIcon[key]) return;
  exports[key] = _VimanaIcon[key];
});